import {CheckCircle2, XCircle} from 'lucide-react'
import { motion } from "framer-motion"

const qualifications = [
  "Já tentou aprender inglês antes",
  "Sente que está travado no básico",
  "Quer melhorar para trabalho, faculdade ou viagens",
  "Quer resultado real, não distração",
]

function ForWhoSection() {
  return (
    <section className="bg-gray-50 py-14 sm:py-20 px-4">
      <div className="max-w-5xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-gray-900 mb-10"
        >
          Esse plano é para você que:
        </motion.h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
          {qualifications.map((q, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="flex items-start gap-3 bg-white rounded-xl p-4 shadow-sm border border-green-100"
            >
              <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
              <span className="text-gray-800 font-medium">{q}</span>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="bg-red-50 border border-red-200 rounded-2xl p-6 text-center"
        >
          <div className="flex items-center justify-center gap-2 mb-2">
            <XCircle className="w-5 h-5 text-red-500" />
            <p className="text-gray-700">
              Não é para quem quer só "dar uma olhadinha".
            </p>
          </div>
          <p className="text-red-600 font-extrabold text-xl">
            É para quem decidiu avançar.
          </p>
        </motion.div>
      </div>
    </section>
  )
}

export default ForWhoSection
